import React from 'react';
import Thumbnail from './Thumbnail';
import { EntityType } from '@constants/attachments';

const CategoryThumbnail = ({
  categoryId,
  categoryName = '',
  size = 'medium',
  className = '',
  thumbnailSize,
  fallbackComponent = null
}) => {
  return (
    <Thumbnail
      entityType={EntityType.CATEGORY}
      entityId={categoryId}
      entityName={categoryName}
      size={size}
      fallbackIcon="📷"
      className={className}
      thumbnailSize={thumbnailSize}
      fallbackComponent={fallbackComponent}
    />
  );
};

export default CategoryThumbnail;
